const AudioManager = require('AudioManager');
const PSEvents = require('PSEvents');
const GenericEngine = require('GenericEngine');

cc.Class({
    extends: cc.Component,

    properties: {
        audioManager: AudioManager
    },

    onLoad () {
        PSEvents.subscribe(PSEvents.COMMON_INITIALIZED, (data) => {
            this._setSoundSettings(data);
            this.registerHandlers();
        });
        PSEvents.subscribe(PSEvents.STATE_UPDATED, (data) => {
            this._setSoundSettings(data);
        });
        PSEvents.subscribe(PSEvents.START_REPLAY, (data) => {
            this.audioManager.stopAllMusic();
            this.audioManager.stopAllSfx();
        });
        PSEvents.subscribe(PSEvents.STOP_REPLAY, (data) => {
            this.audioManager.stopAllMusic();
            this.audioManager.stopAllSfx();
        });

    },

    /**
     * Registers event handlers for CUI.
     */
    registerHandlers () {
        /*
         * Event is fired when cui is opened which causes audioManager to pause sound effects.
         * We want to pause sound effects when CUI is opened otherwise user will see strange behaviour.
         */
        PSEvents.subscribe(PSEvents.MENU_OPENED, () => this.audioManager.handleCUIOpen());

        /*
         * Event is fired when cui is closed which then resumes sound effects
         */
        PSEvents.subscribe(PSEvents.MENU_CLOSED, () => this.audioManager.handleCUIClose());

        /*
        * Event is fired when game is paused (ex. paused by external provider)
        */
        PSEvents.subscribe(PSEvents.GAME_PAUSED, () => this.audioManager.handleCUIOpen());

        /*
        * Event is fired when game is resumed
        */
        PSEvents.subscribe(PSEvents.GAME_RESUMED, () => this.audioManager.handleCUIClose());
    },

    /**
     * Sets audio related settings which are progapated by the CUI fom the Menu.
     * @param data audio settings data object
     */
    _setSoundSettings (data) {
        if (typeof data.fxVolume !== 'undefined') {
            this.audioManager.setSfxVolume(data.fxVolume);
        }

        if (typeof data.musicVolume !== 'undefined') {
            this.audioManager.setMusicVolume(data.musicVolume);
        }

        if (typeof data.masterVolume !== 'undefined') {
            this.audioManager.setGlobalVolume(data.masterVolume);
        }

        if (typeof data.soundEnabled !== 'undefined') {
            this.audioManager.setSoundEnabled(data.soundEnabled);
        }
    }
});
